<ng-template #noteEditorTabsViewTemplate>
  <div
    class="MainNoteTabViewDialog"
    sbbDialog
    (mouseup)="onMouseUp($event)"
    (mousemove)="onMouseMove($event)"
    (mousedown)="onMouseDown($event)"
  >
    <sbb-icon
      class="closeDialog"
      svgIcon="cross-small"
      aria-hidden="false"
      (click)="closeDialog()"
    ></sbb-icon>
    <div class="NoteTabGrupe">
      <sbb-tab-group>
        <sbb-tab [label]="'app.view.dialogs.note-dialog.note-tab' | translate" id="note-tab">
          <sbb-note-edit-element
            [noteDialogParameter]="data"
            (noteDeleted)="closeDialog()"
          ></sbb-note-edit-element>
        </sbb-tab>
        <sbb-tab
          [label]="'app.view.dialogs.note-dialog.filterable-labels-tab' | translate" id="note-filterable-labels-tab"
          *ngIf="!disableBackend"
        >
          <sbb-note-filter-tab
            [noteDialogParameter]="data"
            (noteDeleted)="closeDialog()"
          ></sbb-note-filter-tab>
        </sbb-tab>
      </sbb-tab-group>
    </div>
  </div>
</ng-template>
